import { CanActivateFn, Router } from '@angular/router'
import { firstValueFrom } from 'rxjs'
import { AppStoreService } from '../app-state.service'
import { inject } from '@angular/core'
import { SubscriberAccess } from '../billing/subscriber-access.type'

/**
 * Ensures the user me has been loaded before the guard checks permissions.
 */
async function waitForMe(appStore: AppStoreService) {
    if (appStore.me() !== null) {
        return appStore.me()
    }

    return firstValueFrom(appStore.getMe())
}

export const subscriptionGuard: CanActivateFn = async (route, state) => {
    const appStore = inject(AppStoreService)
    const router = inject(Router)

    if (state.url.split(/[?#]/)[0] === '/subscription') {
        return true
    }

    await waitForMe(appStore)

    const me = appStore.me()

    if (!me || me.subscriberAccessType === SubscriberAccess.Suspended) {
        if (me?.isAdmin) {
            return router.createUrlTree(['/subscription'])
        }

        return router.createUrlTree(['/error'])
    }

    return true
}
